export class SellerSnapshotDatasourceContext {
    datasourceId: number;
    sellerId: number;
    date: Date;
    filterBuilderValue: any;

    constructor(datasourceId: number, sellerId: number, date: Date, filterBuilderValue: any) {
        this.datasourceId = datasourceId;
        this.sellerId = sellerId;
        this.date = date;
        this.filterBuilderValue = filterBuilderValue;
    }
}
